import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const ExpenseForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([])
    const [accountOptions, setAccountOptions] = useState([])

    const [formData, setFormData] = useState({
        category_id: "",
        account_id: "",
        debit: "",
        remark: "",
        date: new Date().toISOString().slice(0, 10),
    })
    const {account_id, category_id, debit, remark, date} = formData
    const navigate = useNavigate()

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {account_id, category_id, debit, remark, date}
        addExpense(payload)
    }
    
    // add expense
    const addExpense = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/expenses/', payload)
            setIsLoading(false)
                toast.success(response.data?.detail)
                setFormData(() => ({
                    category_id: "",
                    account_id: account_id,
                    debit: "",
                    remark: "",
                    date: date,
                }))
                navigate('/add-expense')
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Expense</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="account_id"
                                label="Account"
                                value={account_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('saving-accounts', query, setAccountOptions)}
                                options={accountOptions}
                                placeholder="Start typing to search..."
                                error={errors.account_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('expense-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Amount"
                                name="debit"
                                type="number"
                                label="Amount"
                                value={parseFloat(debit)}
                                onChange={onChange}
                                error={errors.debit}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Date"
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-8">
                            <InputField
                                placeholder="Remark"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Expense" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default ExpenseForm